import React from 'react'
import BudgetsAllBudgets from 'src/app/BudgetsAllBudgets/BudgetsAllBudgets'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { budgetsAllBudgetsRouteProps } from 'src/navigation/routeProps'

const BudgetsAllBudgetsAppRoute: AppRoute = {
  id: AppLocation.BudgetsAll,
  routeProps: budgetsAllBudgetsRouteProps,
  component: <BudgetsAllBudgets />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default BudgetsAllBudgetsAppRoute
